import type { QuickBooksControlCenterList } from '.';

// At most this many pages of one list (25 x 200 = 5,000 rows); a longer
// list is shown truncated and says so (money-lanes.tsx TruncatedNote).
export const MAX_CONTROL_CENTER_LIST_PAGES = 25;

// The rest of a list after its first page, read page by page at the same
// page size. A page that fails, comes back empty, or was answered from
// another revision of the projection (another asOf or total) ends the read:
// the rows returned are always one revision, and `pagination.total` keeps
// the server's total so the screen says how many it could not show.
export const readRemainingControlCenterPages = async (
  first: QuickBooksControlCenterList,
  read: (
    offset: number
  ) =>
    | PromiseLike<{ data?: unknown; error?: unknown }>
    | { data?: unknown; error?: unknown }
): Promise<QuickBooksControlCenterList> => {
  const total = first.pagination?.total;
  if (typeof total !== 'number' || (first.pagination?.offset ?? 0) !== 0) {
    return first;
  }
  const rows = [...(first.rows || [])];
  let pages = 1;
  while (rows.length < total && pages < MAX_CONTROL_CENTER_LIST_PAGES) {
    const page = await read(rows.length);
    pages += 1;
    const data = page.data as QuickBooksControlCenterList | undefined;
    if (
      page.error ||
      !data?.rows?.length ||
      data.asOf !== first.asOf ||
      data.pagination?.total !== total
    ) {
      break;
    }
    rows.push(...data.rows);
  }
  return {
    ...first,
    rows,
    pagination: { total, offset: 0, limit: rows.length },
  };
};
